import { applyMiddleware, createStore } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogicMiddleware } from 'redux-logic';

import sentryReduxMiddleware from 'lib/sentryReduxMiddleware';
import createRootReducer from './createRootReducer';
import rootLogic from './rootLogic';
import { History } from 'history';

interface CreateStoreArgs {
  history: History;
}

export default ({ history }: CreateStoreArgs) => {
  const logicMiddleware = createLogicMiddleware(rootLogic);

  const store = createStore(
    createRootReducer(history),
    composeWithDevTools(applyMiddleware(routerMiddleware(history), logicMiddleware, sentryReduxMiddleware)),
  );

  return { store, logicMiddleware };
};
